define(["data/config"], function(config) {
    var debounce = function(fn, ms, immediate) {
        var timeout;
        return function() {
            var context = this, args = arguments;
            var later = function() {
                timeout = null;
                if (!immediate) {
                    fn.apply(context, args);
                }
            }
            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, ms);
            if (callNow) {
                fn.apply(context, args);
            }
        };
    }

    var $searchResults = [];
    var $searchField = [];

    var events = function($searchField, $searchResults) {
        var keyup = function(e) {
            if (
                e.keyCode == 38 ||
                e.keyCode == 40 ||
                e.keyCode == 13 ||
                e.keyCode == 27
            )
                return;
            if ($(this).val() == '') {
                render([], '', $searchResults);
            } else {
                var query = $('<div>')
                    .html($(this).val())
                    .text();
                if (
                    typeof request === 'object' &&
                    request.readyState &&
                    request.readyState !== 4 &&
                    request.abort
                ) {
                    request.abort();
                }
                request = $.ajax({
                    type: 'GET',
                    url: 'https://index.co/api/search/companies',
                    data: {
                        q: query,
                    },
                    success: function(data) {
                        render(data, query, $searchResults);
                    },
                    dataType: 'json',
                    beforeSend: function() {
                        if (typeof request !== 'undefined') {
                            request.abort();
                        }
                    },
                });
            }
        }

        $($searchField).on('keyup', debounce(keyup, 200));

        $($searchField).on('blur', function(e) {
            setTimeout(function() {
                $searchResults.hide();
            }, 500);
        });
    };

    var swapForm = function(target) {
        $(".js_selected").remove();
        $searchField.val('');
        $searchField.removeAttr('required');

        $($(target)[0].outerHTML).addClass('js_selected').removeClass('js_fill').insertBefore($searchResults).one('click', function(ev) {
            $(".js_selected").remove();
            $searchField.val('').focus();
            $searchField.prop('required',true);
        });
        var $input = $('<input type="hidden">')
            .attr('class', 'js_selected')
            .attr('name', 'company_index_id')
            .attr('value', $(target).data('companyid'));
        $input.insertBefore($searchResults);
        $searchResults.hide();
        $searchField.val($(target).find('.c_identity-info-name')[0].textContent);
    };

    var render = function(data, query, $searchResults) {
        list = '<ul>';
        nitems = data.length;
        if (data.length > 0) {
            $.each(data, function(index, object) {
                list += template(index, object);
            });
        }
        list += '</ul>';
        $searchResults.html(list);
        $searchResults.one('click', '.js_fill', function(ev) {
            swapForm($(ev.target).parents('.js_fill'));
        });

        if (!data.length) {
            var $advSearchBlock = $(
                '<li><a class="c_identity"><div class="c_identity-info"><strong class="c_identity-info-name">No results found</strong><span class="c_identity-info-stats">Don\'t worry, just type the full company name</span></div></a></li>'
            );
            $searchResults.children().append($advSearchBlock);
        } else {
            var $claimBlock = $(`
            <li><a class="c_identity"><div class="c_identity-info"><strong class="c_identity-info-name">None of the above?</strong><span class="c_identity-info-stats">Check your spelling then click here to move on to the next question</span></div></a></li>`);
            $claimBlock.one('click', function() {
                $searchResults.hide();
                $(".js_selected").remove();
                $searchField.focus();
            });
            $searchResults.children().append($claimBlock);
        }
        $searchResults.show();
    };

    var template = function(index, object) {
        var avatar = '<div class="c_identity-avatar"><img src="' + object.pic + '"></div>';
        var item = '<li>';
             item +=
                 "<a class='c_identity js_fill' data-companyid='" +
                 object.id +
                 "'>";
        item += avatar + '<div class="c_identity-info">';
        if (object.desc) {
            item +=
                "<span class='c_identity-info-name'>" +
                object.name +
                '</span>' +
                "<span class='c_identity-info-stats'>" +
                object.desc +
                '</span>';
        } else {
            item +=
                "<span class='c_identity-info-name'>" +
                object.name +
                '</span>';
        }
        item += '</div>';
        item += '</a>';
        item += '</li>';
        return item;
    };

    var apply = function($element) {
        $searchField = $element;
        $searchResults = $('<div></div>')
        .attr({
            class: 'c_searchResultsAjax',
        })
        .hide();
        $element.after($searchResults);
        events($element, $searchResults);
    };

    return {
        name: "companySelector",
        apply: apply
    };
});
